<script>
export default {
    name: 'AccountReservations',
    inject: ['account'],
    computed: {
        reservations() {
            return this.account.upcomingReservationsData
                ? this.account.upcomingReservationsData.future
                : null
        }
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Reservas Próximas</h4>
            <p class="text-muted mb-0">Tus sesiones de simulador programadas.</p>
        </div>

        <b-table-simple v-if="reservations && reservations.length > 0" responsive class="account-reservations-table">
            <b-thead>
                <b-tr>
                    <b-th>Fecha y Hora</b-th>
                    <b-th>Simulador</b-th>
                    <b-th colspan="2">&nbsp;</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="(reserv, i) in reservations" :key="i">
                    <b-td class="text-nowrap">{{ reserv.getDateFormatted() }} @ {{ reserv.getTimeFormatted() }}</b-td>
                    <b-td>{{ reserv.attributes.calendar_name }}</b-td>
                    <b-td class="text-nowrap">
                        <a :href="reserv.getAddToCalendarLink()"><b-icon icon="calendar-plus" /> Añadir al Calendario</a>
                    </b-td>
                    <b-td class="text-nowrap">
                        <b-link :to="{ name: 'calendarControlWaitingRoom', params: { calendarId: reserv.attributes.calendar } }">
                            <b-icon icon="controller" /> Ir al Controlador de Sim
                        </b-link>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-card v-else-if="reservations !== null" class="text-center py-5">
            <b-icon icon="cone-striped" style="color: #ed8d34; font-size: 2.5rem;" class="d-block mx-auto mb-3" />
            <p class="text-muted mb-3">No tienes reservas próximas.</p>
            <b-button variant="secondary" :to="{ name: 'reservations' }">Ver Disponibilidad</b-button>
        </b-card>

        <b-card v-else class="text-center py-4">
            <b-spinner small class="mr-2" />
            <span class="text-muted">Cargando reservas…</span>
        </b-card>
    </div>
</template>

<style scoped>
.account-reservations-table td,
.account-reservations-table th {
    white-space: nowrap;
}
</style>
